// Same marker the backend uses to keep internal/test accounts out of the team's
// Telegram notifications (promobile-back: common/helpers/telegram-notifier.ts,
// auth.service.ts).
export const INTERNAL_EMAIL_MARKER = "promobile-internal";

const hasInternalMarker = (value?: string | null) =>
  (value || "").toLowerCase().includes(INTERNAL_EMAIL_MARKER);

// The marker in the email or in the name, as the backend's keyword fetch
// filters users (promobile-back: scraper/scraper.service.ts).
export const isInternalUser = (
  user?: { email?: string | null; name?: string | null } | null,
) => hasInternalMarker(user?.email) || hasInternalMarker(user?.name);
